import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { cssRaw } from 'typestyle';
import { BlackOpacity07 } from '@traceair/tds';
import App from './App';
import { BreakpointProvider } from './hooks/useBreakpoint';

const root = ReactDOM.createRoot(document.getElementById('main') as HTMLElement);

root.render(
  <BreakpointProvider>
    <App />
  </BreakpointProvider>,
);

cssRaw(`
  html {
    background: ${BlackOpacity07}
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  html, body, #main {
    width: 100%;
    height: 100%;
    margin: 0;
    box-sizing: border-box;
  }

  button {
    background: none;
    border: none;
    padding: 0;
    outline: none;
    cursor: pointer;
    text-align: left;
  }
`);
